// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__xSrBq","content":"styles_content__h2LZr","stickyMobileNav":"styles_stickyMobileNav__Xh9WJ"};